const ar = {
  nav: {
    dashboard: "لوحة التحكم",
    messages: "الرسائل",
    calls: "المكالمات",
    calendar: "التقويم",
    automations: "الأتمتة",
    marketing: "التسويق",
    orders: "الطلبات",
    customers: "العملاء",
    analytics: "التحليلات",
    settings: "الإعدادات",
    integrations: "التكاملات",
    notifications: "التنبيهات",
    logout: "تسجيل الخروج",
    products: "المنتجات",
    tasks: "المهام",
    billing: "الفواتير",
    support: "الدعم",
    myBusiness: "عملي",
    restaurantEditor: "محرر المطعم",
    liveRoom: "الغرفة المباشرة",
    myProfile: "ملفي الشخصي",
    team: "الفريق",
    help: "المساعدة",
    ai: "مساعد الذكاء الاصطناعي",
    logs: "السجلات",
    alerts: "التنبيهات",
    whatsapp: "واتساب",
  },

  common: {
    loading: "جاري التحميل...",
    save: "حفظ",
    saving: "جاري الحفظ...",
    saved: "تم الحفظ",
    error: "خطأ",
    openNavigation: "فتح القائمة",
    cancel: "إلغاء",
    delete: "حذف",
    edit: "تعديل",
    search: "بحث",
    filter: "تصفية",
    actions: "إجراءات",
    status: "الحالة",
    type: "النوع",
    name: "الاسم",
    email: "البريد الإلكتروني",
    phone: "الهاتف",
    date: "التاريخ",
    total: "الإجمالي",
    empty: "لا توجد نتائج",
    perPage: "لكل صفحة",
    purchases: "المشتريات",
    whatsapp: "واتساب",
    noData: "لا توجد بيانات",
    back: "رجوع",
    next: "التالي",
    previous: "السابق",
    yes: "نعم",
    no: "لا",
    confirm: "تأكيد",
    close: "إغلاق",
    open: "فتح",
    add: "إضافة",
    remove: "إزالة",
    update: "تحديث",
    creating: "جاري الإنشاء...",
    updating: "جاري التحديث...",
    deleting: "جاري الحذف...",
    created: "تم الإنشاء",
    updated: "تم التحديث",
    deleted: "تم الحذف",
    viewAll: "عرض الكل",
    manage: "إدارة",
    all: "الكل",
    manual: "يدوي",
    bookings: "الحجوزات",
    booking: "حجز",
    of: "من",
    page: "صفحة",
    noResults: "لا توجد نتائج",
    view: "عرض",
    online: "متصل",
    offline: "غير متصل",
    origin: "المصدر",
    optional: "اختياري",
    create: "إنشاء",
    select: "تحديد",
    filters: "الفلاتر",
  },

  topbar: {
    client: "العميل",
    profile: "الملف الشخصي",
    logout: "تسجيل الخروج",
    defaultClient: "افتراضي",
  },

  status: {
    online: "متصل",
    offline: "غير متصل",
    pending: "قيد الانتظار",
    completed: "مكتمل",
    cancelled: "ملغي",
    processing: "جاري المعالجة",
    shipped: "تم الشحن",
    delivered: "تم التسليم",
    refunded: "تم الإرجاع",
    confirmed: "مؤكد",
    paid: "مدفوع",
    onHold: "قيد الانتظار",
    failed: "فاشل",
    pendingArrival: "في الطريق 🟠",
    checkedIn: "تسجيل وصول",
    inHouse: "في الموقع",
    checkedOut: "تسجيل مغادرة",
    noShow: "عدم حضور",
  },

  time: {
    now: "الآن",
    minutesAgo: "منذ {{count}} د",
    hoursAgo: "منذ {{count}} س",
    daysAgo: "منذ {{count}} ي",
    minutes_short: "د",
    hours_short: "س",
    days_short: "ي",
  },

  customers: {
    title: "العملاء",
    subtitle: "عملاء واتساب، المتجر الإلكتروني والعملاء المضافين يدوياً",
    detail: "تفاصيل العميل",
    newCustomer: "عميل جديد",
    editCustomer: "تعديل العميل",
    backToCustomers: "العودة للعملاء",
    createOffer: "إنشاء عرض",
    deleteTitle: "حذف العميل؟",
    deleteConfirm: "سيتم حذف {{name}}. لا يمكن التراجع عن هذا الإجراء.",
    thisCustomer: "هذا العميل",
    noName: "بدون اسم",
    searchPlaceholder: "الاسم، البريد أو الهاتف...",
    noResultsWithFilters: "لم يتم العثور على عملاء بالفلاتر المطبقة",
    totalSpent: "إجمالي الإنفاق",
    segments: {
      all: "جميع الفئات",
      new: "جديد (≤1 طلب)",
      recurring: "متكرر (≥2)",
      inactive: "غير نشط (+60ي)",
      topSpenders: "الأكثر إنفاقاً",
      topOrders: "الأكثر طلباً",
      recent: "الأحدث",
    },
    table: {
      name: "الاسم",
      customer: "العميل",
      contact: "الاتصال",
      totalSpent: "إجمالي الإنفاق",
      orders: "الطلبات",
      lastActivity: "آخر نشاط",
      actions: "إجراءات",
      origin: "المصدر",
    },
    contactMissing: "بيانات الاتصال مفقودة",
    empty: "لا يوجد عملاء",
    noBookings: "لا توجد حجوزات",
    perPage: "لكل صفحة",
    filters: {
      channel: "القناة",
      date: "التاريخ",
    },
    details: {
      contactInfo: "معلومات الاتصال",
      orderHistory: "سجل الطلبات",
      notes: "ملاحظات",
      totalSpent: "إجمالي الإنفاق",
      lifetimeValue: "القيمة الإجمالية",
      averageOrder: "متوسط الطلب",
      averageTicket: "متوسط التذكرة",
      firstOrder: "أول طلب",
      lastOrder: "آخر طلب",
      lastMessage: "آخر رسالة",
      registered: "مسجل",
      recentActivity: "النشاط الأخير",
      ordersOrBookings: "الطلبات/الحجوزات",
      viewAllOrders: "عرض كل الطلبات",
      note: "ملاحظة",
      tags: "الوسوم",
    },
    placeholders: {
      name: "محمد العلمي",
      email: "customer@email.com",
      phone: "+212 6XX XXX XXX",
      notes: "ملاحظات عن هذا العميل...",
      addTag: "أضف وسماً واضغط Enter…",
      writeNote: "اكتب ملاحظة عن هذا العميل…",
    },
    errors: {
      atLeastOneField: "أضف اسماً أو بريداً أو هاتفاً على الأقل",
    },
  },

  orders: {
    title: "الطلبات",
    detail: "تفاصيل الطلب",
    unifiedDescription: "قائمة موحدة — ووكومرس، شوبيفاي وبريستاشوب.",
    searchPlaceholder: "بحث برقم الطلب، العميل، البريد...",
    ordersCount: "طلبات",
    showing: "عرض",
    loadingDetail: "جاري تحميل التفاصيل...",
    reminder: "تذكير",
    return: "إرجاع",
    returnType: "إرجاع",
    exchangeType: "استبدال",
    createRequest: "إنشاء طلب",
    reminderWhat: "ماذا يجب أن نفعل؟",
    reminderPlaceholder: "مثال: إرسال الطلب الأسبوع القادم",
    reasonPlaceholder: "صف سبب الإرجاع أو الاستبدال...",
    notFound: "الطلب غير موجود",
    table: {
      order: "الطلب",
      date: "التاريخ",
      customer: "العميل",
      total: "الإجمالي",
      status: "الحالة",
      items: "العناصر",
      origin: "المصدر",
      actions: "إجراءات",
      view: "عرض",
    },
    empty: "لا توجد طلبات",
    perPage: "لكل صفحة",
    shipping: "الشحن",
    refundRequest: "طلب إرجاع / استبدال",
    internalNotes: "ملاحظات داخلية",
    newReminder: "تذكير جديد",
    reminderDateTime: "التاريخ / الوقت (اختياري)",
    reason: "السبب",
    history: "السجل",
    purchases: "المشتريات",
    totalSpent: "إجمالي الإنفاق",
    nameAZ: "الاسم أ-ي",
    filters: {
      allOrders: "جميع الطلبات",
      pending: "قيد الانتظار",
      processing: "جاري المعالجة",
      completed: "مكتمل",
      cancelled: "ملغي",
      dateRange: "نطاق التاريخ",
    },
    details: {
      orderInfo: "معلومات الطلب",
      customerInfo: "معلومات العميل",
      items: "العناصر",
      shippingAddress: "عنوان الشحن",
      billingAddress: "عنوان الفواتير",
      paymentMethod: "طريقة الدفع",
      shippingMethod: "طريقة الشحن",
      subtotal: "المجموع الفرعي",
      shippingCost: "تكلفة الشحن",
      taxes: "الضرائب",
      discount: "الخصم",
      total: "الإجمالي",
    },
    errors: {
      cannotSaveStatus: "تعذر حفظ الحالة",
      cannotSaveReminder: "خطأ في حفظ التذكير",
      cannotCreateReturn: "خطأ في إنشاء الطلب",
    },
  },

  dashboard: {
    title: "لوحة التحكم",
    subtitle: "نظرة عامة فورية على عملك",
    whatsappMessages: "رسائل واتساب",
    totalCustomers: "إجمالي العملاء",
    recentMessages: "الرسائل الأخيرة",
    latestOrders: "أحدث الطلبات",
    latestBookings: "أحدث الحجوزات",
    activity: "النشاط",
    messages: "الرسائل",
    runs: "عمليات",
    success: "نجاح",
    contacts: "جهات اتصال",
    new: "جديد",
    people: "أشخاص",
    upcoming: "القادمة",
    appointments: "المواعيد",
    bookings: "الحجوزات",
    patients: "المرضى",
    newThisPeriod: "جديد هذه الفترة",
    noRecentMessages: "لا توجد رسائل حديثة",
    noRecentOrders: "لا توجد طلبات حديثة",
    noRecentBookings: "لا توجد حجوزات حديثة",
    noText: "(بدون نص)",
    createFirstAutomation: "إنشاء أول أتمتة ←",
    last7Days: "7 أيام",
    last30Days: "30 يوماً",
    nucleo: "النواة",
    dispatches: "الإرساليات",
    totalProcessedEvents: "إجمالي الأحداث المعالجة",
    successfulDispatches: "عمليات إرسال ناجحة",
    matchedStatusDesc: "الإرساليات بحالة 'مطابقة'",
    failedDispatches: "عمليات إرسال فاشلة",
    errorStatusDesc: "الإرساليات بحالة 'خطأ'",
    skippedDispatches: "تم تخطيها / مكررة",
    skippedStatusDesc: "الإرساليات بحالة 'تم التخطي'",
    operationalMonitoring: "المراقبة التشغيلية",
    noRecentEvents: "لا توجد أحداث أخيرة.",
    aiTrigger: "محفز الذكاء الاصطناعي",
    regexFallback: "تراجع التعبير النمطي",
    event: "حدث",
  },

  marketing: {
    newCampaign: "حملة جديدة",
    email: "البريد الإلكتروني",
    sms: "SMS",
    whatsapp: "واتساب",
    social: "التواصل الاجتماعي",
    scheduled: "مجدولة",
    sent: "أُرسلت",
    subtitle: "قوالب وحملات لـ {{name}}",
    yourBusiness: "عملك",
    newTemplate: "قالب جديد",
    editTemplate: "تعديل القالب",
    createTemplate: "إنشاء قالب",
    templateUpdated: "تم تحديث القالب",
    templateCreated: "تم إنشاء القالب",
    templateDeleted: "تم حذف القالب",
    errorDeleting: "خطأ في الحذف",
    confirmDelete: "حذف هذا القالب؟",
    varsHint: "يتم اكتشاف المتغيرات تلقائياً باستخدام {{variable}}",
    templateName: "اسم القالب",
    subject: "الموضوع",
    message: "الرسالة",
    characters: "حروف",
    detectedVars: "المتغيرات المكتشفة",
    variableLabel: "تسمية",
    allowReplies: "السماح بردود العملاء",
    launchCampaign: "إطلاق حملة",
    campaignName: "اسم الحملة",
    audienceSegment: "شريحة الجمهور",
    templateVars: "متغيرات القالب",
    preview: "معاينة",
    scheduleSend: "جدولة الإرسال",
    reach: "الوصول المتوقع",
    sendType: "نوع الإرسال",
    immediate: "فوري",
    replies: "الردود",
    allowed: "مسموح بها",
    disabled: "معطلة",
    schedule: "جدولة",
    sendNow: "إرسال الآن",
    yours: "خاص بك",
    campaignLaunched: "تم إطلاق الحملة لـ ~{{count}} جهة اتصال",
    searchPlaceholder: "البحث عن قوالب...",
    templates: "قوالب",
    template: "قالب",
    loading: "جاري تحميل القوالب...",
    yourTemplates: "قوالبك",
    new: "جديد",
    noOwnTemplates: "لا توجد قوالب خاصة",
    createFirstHint: "أنشئ أول قالب مخصص لك",
    zepelinTemplates: "قوالب زبلين",
    available: "متاحة",
    zepelinTemplatesDesc: "قوالب احترافية أنشأها فريق زبلين. يتم تحديثها مع الأعياد والاتجاهات الجديدة. للقراءة فقط — استخدمها مباشرة أو كقاعدة لقوالبك.",
    segments: {
      all: "جميع جهات الاتصال",
      allDesc: "قاعدة بيانات CRM الكاملة",
      recent30: "آخر 30 يوماً",
      recent30Desc: "جهات الاتصال المنشأة حديثاً",
      recent90: "آخر 90 يوماً",
      recent90Desc: "عملاء الربع السنوي",
      withBookings: "مع حجوزات",
      withBookingsDesc: "قاموا بحجز واحد على الأقل",
      noShow: "عدم الحضور",
      noShowDesc: "لم يحضروا لحجزهم",
      vip: "VIP (3+ حجوزات)",
      vipDesc: "عملاء متكررون",
    },
    placeholders: {
      emailBody: "مرحباً {{nombre}}،\n\nنأمل أن تكون بخير...",
      whatsappBody: "مرحباً {{nombre}}، نذكرك بحجزك لغد الساعة {{hora}}...",
      templateName: "مثال: تذكير بحجز العشاء",
      subject: "موضوع البريد الإلكتروني",
    },
    stats: {
      total: "إجمالي جهات الاتصال",
      withEmail: "مع بريد إلكتروني",
      withPhone: "مع هاتف",
      new30d: "جديد 30 يوم",
    },
  },

  analytics: {
    title: "التحليلات",
    overview: "نظرة عامة",
    revenue: "الإيرادات",
    today: "اليوم",
    yesterday: "أمس",
    noChange: "لا تغيير",
    vsPrevious: "مقارنة بالفترة السابقة",
    noDataPeriod: "لا توجد بيانات في هذه الفترة",
    last7Days: "آخر 7 أيام",
    last30Days: "آخر 30 يوماً",
    updating: "جاري التحديث...",
    updatedAt: "تم التحديث في {{time}}",
    loading: "جاري التحميل...",
    "7days": "7 أيام",
    "30days": "30 يوماً",
    totalMessages: "إجمالي الرسائل",
    messagesSummary: "{{in}} مستلمة · {{out}} مرسلة",
    conversations: "المحادثات",
    uniqueThreads: "سلاسل فريدة",
    newContacts: "جهات اتصال جديدة",
    crmTotal: "{{count}} إجمالي في CRM",
    confirmedBookings: "الحجوزات المؤكدة",
    bookingsSummary: "{{cancelled}} ملغاة · {{pending}} قيد الانتظار",
    messageActivity: "نشاط الرسائل",
    sent: "مرسلة",
    received: "مستلمة",
    templates: "قوالب",
    failed: "فاشلة",
    estimatedCost: "التكلفة التقديرية",
    contactBase: "قاعدة جهات الاتصال",
    withEmail: "مع بريد إلكتروني",
    withPhone: "مع هاتف",
    newThisWeek: "جديد هذا الأسبوع",
    totalCrm: "إجمالي CRM",
    activePlan: "الخطة النشطة",
    month: "شهر",
    noActiveSubscription: "لا يوجد اشتراك نشط",
    voiceBalance: "رصيد الصوت",
    min: "دقيقة",
    smsBalance: "رصيد SMS",
    campaigns: "الحملات",
    messagingChannels: "قنوات المراسلة",
    bookingStatus: "حالة الحجوزات",
    noBookings: "لا توجد حجوزات مسجلة",
    totalHistory: "الإجمالي التاريخي",
  },

  calendar: {
    title: "التقويم",
    loading: "جاري تحميل التقويم...",
    personalAgenda: "الأجندة الشخصية",
    stayManagement: "إدارة الإقامة",
    consultationManagement: "إدارة الاستشارات",
    appointmentManagement: "إدارة المواعيد",
    bookingManagement: "إدارة الحجوزات",
    weekOf: "أسبوع",
    more: "أكثر",
    appointmentsThisWeek: "مواعيد هذا الأسبوع",
    newAppointment: "موعد جديد",
    today: "اليوم",
    month: "شهر",
    week: "أسبوع",
    day: "يوم",
    agenda: "الأجندة",
    events: "الأحداث",
    newEvent: "حدث جديد",
    editEvent: "تعديل الحدث",
    deleteEvent: "حذف الحدث",
    eventDetails: "تفاصيل الحدث",
    allDay: "طوال اليوم",
    starts: "يبدأ",
    ends: "ينتهي",
    repeat: "تكرار",
    location: "الموقع",
    description: "الوصف",
    attendees: "الحضور",
    addAttendee: "إضافة حاضر",
    reminders: "التذكيرات",
    previous: "السابق",
    next: "التالي",
    hour: "الساعة",
    addEvent: "إضافة {{event}}",
    checkin: "تسجيل وصول",
    checkout: "تسجيل مغادرة",
    inHouse: "في الموقع",
    roomMap: "خريطة الغرف",
    freeRoom: "غرفة شاغرة",
    bookedVia: "حجز عبر",
    createdOn: "أُنشئ في",
    deletePermanently: "حذف نهائي",
    selectedDay: "اليوم المحدد",
    allStatuses: "جميع الحالات",
    active: "نشط",
    cancelledNoShow: "ملغي / عدم حضور",
    exportCsv: "تصدير CSV",
    new: "جديد",
    ofTheDay: "لهذا اليوم",
    clickForDetails: "اضغط للتتفاصيل",
    noEventsForDay: "لا توجد {{event}} لهذا اليوم",
    tablePlaceholder: "مثال: 2 ← طاولة 2",
    startTime: "وقت البدء",
    endTime: "وقت الانتهاء",
    duration: "المدة",
    professional: "المهني",
    professionalPlaceholder: "اسم المهني",
    service: "الخدمة",
    servicePlaceholder: "مانيكير، مساج...",
    department: "القسم",
    departmentPlaceholder: "أمراض القلب...",
    doctor: "الطبيب",
    doctorPlaceholder: "د. اللقب",
    patientName: "اسم المريض",
    patientPlaceholder: "محمد الفاسي",
    clientName: "اسم العميل",
    clientPlaceholder: "أمينة الخطابي",
    guestName: "اسم الضيف",
    guestPlaceholder: "عائلة بنسودة",
    bookingName: "اسم الحجز",
    bookingPlaceholder: "حجز عيد ميلاد",
    editAppointment: "تعديل الموعد",
    titleSubject: "العنوان / الموضوع",
    titlePlaceholder: "مثال: اجتماع عميل، استشارة...",
    notesPlaceholder: "أي تفاصيل ذات صلة...",
    hours: "ساعات",
    appointment: "موعد",
    room: "غرفة",
    guests: "ضيوف",
    pax: "Pax",
    tableRoom: "طاولة/غرفة",
    start: "بدء",
    end: "انتهاء",
    title: "العنوان",
    bookingHistory: "سجل الحجوزات",
    noBookingsRegistered: "لا توجد حجوزات مسجلة",
    paxShort: "شخص",
    table: "طاولة",
  },

  messages: {
    title: "الرسائل",
    threads: "المحادثات",
    noThreads: "لا توجد محادثات",
    noSubject: "(بدون موضوع)",
    selectThread: "اختر محادثة",
    noMessages: "لا توجد رسائل",
    you: "أنا",
    contact: "جهة الاتصال",
    typeMessage: "اكتب رسالة...",
    send: "إرسال",
    sending: "جاري الإرسال...",
    inbox: "الوارد",
    sent: "المرسل",
    drafts: "المسودات",
    archived: "المؤرشفة",
    spam: "رسائل مزعجة",
    trash: "السلة",
    compose: "إنشاء",
    reply: "رد",
    forward: "توجيه",
    delete: "حذف",
    markAsRead: "تعيين كمقروء",
    markAsUnread: "تعيين كغير مقروء",
    archive: "أرشفة",
    search: "بحث في الرسائل...",
    selectConversation: "اختر محادثة",
    attachments: "المرفقات",
    messageSent: "تم إرسال الرسالة",
    messageFailed: "فشل إرسال الرسالة",
    sendMessage: "إرسال رسالة",
    sendTemplate: "إرسال قالب",
    previews: {
      noMessages: "لا توجد رسائل حديثة",
      audio: "صوت",
      image: "صورة",
      video: "فيديو",
      location: "موقع",
      document: "مستند",
      template: "قالب",
    },
    header: {
      aiPaused: "🤖 تم إيقاف الذكاء الاصطناعي مؤقتًا - تم تفعيل الوضع اليدوي",
      aiReactivated: "🤖 تمت إعادة تفعيل الذكاء الاصطناعي",
      aiError: "خطأ في تغيير حالة الذكاء الاصطناعي",
      resolved: "تم الحل",
      reopened: "تمت إعادة الفتح",
      archived: "تم الأرشفة",
      unarchived: "تم إلغاء الأرشفة",
      addedFromInbox: "تمت الإضافة من البريد الوارد",
      contactSaved: "تم حفظ جهة الاتصال",
      saveError: "خطأ في الحفظ",
      addContact: "إضافة جهة اتصال",
      editContact: "تعديل جهة الاتصال",
      contactNamePlaceholder: "اسم جهة الاتصال",
      saveContact: "حفظ جهة الاتصال",
      conversation: "محادثة",
      reopen: "إعادة فتح",
      resolve: "حل",
      unarchive: "إلغاء الأرشفة",
      archive: "أرشفة",
      pauseAiHint: "إيقاف الذكاء الاصطناعي والرد يدويًا",
      pauseAi: "إيقاف الذكاء الاصطناعي",
      activateAiHint: "إعادة تفعيل الذكاء الاصطناعي",
      activateAi: "تفعيل الذكاء الاصطناعي",
      closeConversation: "إغلاق المحادثة",
    },
    input: {
      addDescription: "إضافة وصف...",
      fileTooLarge: "كبير جداً",
      attachError: "خطأ في إرفاق الملف",
      sendError: "خطأ في الإرسال",
      placeholder: "اكتب رسالة...",
    },
    templates: {
      title: "إرسال قالب واتساب",
      loading: "جاري تحميل القوالب...",
      none: "لا توجد قوالب معتمدة",
      select: "اختر قالباً",
      variables: "متغيرات",
      change: "تغيير القالب",
      variable: "متغير",
      valueFor: "قيمة لـ",
      preview: "معاينة",
      sent: "تم إرسال القالب",
      sendError: "خطأ في إرسال القالب",
    },
    location: {
      title: "إرسال الموقع",
      searchPlaceholder: "بحث عن مكان...",
      useCurrent: "استخدام موقعي الحالي",
      gettingLocation: "جاري الحصول على الموقع...",
      searchError: "خطأ في البحث عن الموقع",
      geoNotAvailable: "تحديد الموقع غير متاح",
      geoError: "تعذر الحصول على الموقع",
      sent: "تم إرسال الموقع",
      sendError: "خطأ في إرسال الموقع",
      change: "← تغيير الموقع",
      map: "خريطة",
      mapNotAvailable: "الخريطة غير متاحة",
      viewOnMaps: "عرض على خرائط جوجل",
    },
    bubbles: {
      download: "تنزيل",
      tapToDownload: "اضغط للتنزيل",
      retry: "إعادة المحاولة",
      sharedLocation: "موقع مشترك",
      whatsappTemplate: "قالب واتساب",
    },
    voice: {
      error: "تعذر الوصول إلى الميكروفون",
      recording: "جاري التسجيل...",
      label: "تسجيل رسالة صوتية",
    }
  },

  integrations: {
    title: "التكاملات",
    subtitle: "اربط أدواتك المفضلة وأتمت سير عملك",
    loadingAccount: "جاري جلب معلومات حسابك",
    noActiveSession: "لا توجد جلسة نشطة",
    noTenantFound: "لم يتم العثور على tenant صالح. يرجى تسجيل الدخول مجدداً.",
    goToLogin: "الذهاب لتسجيل الدخول",
    activeTenant: "الـ Tenant النشط",
    connected: "متصلة",
    syncing: "جاري المزامنة",
    failed: "فاشلة",
    searchPlaceholder: "بحث عن تكامل...",
    noIntegrationsFound: "لم يتم العثور على تكاملات",
    tryDifferentSearch: "جرب كلمات بحث أخرى أو اختر فئة مختلفة",
    noIntegrationsAvailable: "لا توجد تكاملات متاحة حالياً",
    disconnect: "فصل",
    disconnectConfirm: "هل أنت متأكد من رغبتك في فصل هذا التكامل؟",
    needIntegration: "هل تحتاج إلى تكامل غير موجود؟",
    contactUs: "اتصل بنا لتطويره",
    configure: "تكوين",
    settings: "الإعدادات",
    status: "الحالة",
    lastSync: "آخر مزامنة",
    sync: "مزامنة",
    syncingStatus: "جاري المزامنة...",
    connect: "ربط",
    connecting: "جاري الربط...",
    disconnecting: "جاري الفصل...",
    configureFirst: "التكوين أولاً",
    configureIntegration: "تكوين {{name}}",
    saveAndConnect: "حفظ وربط",
    notConnected: "غير متصل",
    oauthAuth: "توثيق OAuth",
    credentials: "بيانات الاعتماد",
    secureAuth: "✨ تفويض آمن",
    oauthDescription: "اضغط على \"ربط\" وسيتم تحويلك إلى {{name}} لتفويض الوصول.",
    oauthBenefits: {
      noExposure: "✓ لا يتم الكشف عن بيانات الاعتماد",
      secure: "✓ آمن ومشفّر",
      revocable: "✓ يمكن إلغاؤه في أي وقت",
    },
    noCredentialsRequired: "لا توجد بيانات اعتماد إضافية مطلوبة.",
    testConnection: "اختبار الاتصال",
    connectionSuccessful: "تم الاتصال بنجاح. البيانات صالحة.",
    connectionError: "خطأ في الاتصال. تحقق من البيانات.",
    networkError: "خطأ في الشبكة أثناء الاختبار",
    invalidCredentials: "بيانات اعتماد غير صالحة",
    noTenantSelected: "لم يتم اختيار tenant",
    processing: "جاري المعالجة...",
    reconnect: "إعادة الربط",
    apiKeys: "مفاتيح API",
    inDevelopment: "صفحة التكاملات قيد التطوير.",
    connectedLabel: "متصلة",
    totalLabel: "تكاملات",
    failedLabel: "مع خطأ",
    clearSearch: "مسح البحث",
    available: "متاحة",
    connectWhatsApp: "ربط واتساب",
    showValue: "إظهار القيمة",
    hideValue: "إخفاء القيمة",
    officialDocs: "الوثائق الرسمية",

    woocommerce: {
      oauthRecommended: "OAuth (موصى به)",
      apiKeysAlternative: "مفاتيح API (بديل)",
      oauthTitle: "الاتصال عبر OAuth (بنقرة واحدة)",
      oauthDescription: "تحتاج فقط إلى رابط متجرك. سيتم توجيهك إلى WooCommerce لتفويض الاتصال.",
      apiKeysTitle: "الاتصال عبر مفاتيح API",
      apiKeysDescription: "استخدم مفاتيح API إذا كان متجرك لا يحتوي على SSL أو إذا كنت تفضل هذه الطريقة.",
      siteUrl: "رابط المتجر",
      consumerKey: "مفتاح المستهلك (Consumer Key)",
      consumerSecret: "سر المستهلك (Consumer Secret)",
    },

    instructions: {
      woocommerce: {
        title: "ربط WooCommerce - طريقتان",
        steps: "🔐 OAuth (موصى به):\n• أدخل رابط متجرك\n• انقر على \"اتصال\"\n• سيتم توجيهك إلى WooCommerce للتفويض\n\n🔑 مفاتيح API (بديل):\n• اذهب إلى WooCommerce ← الإعدادات ← متقدم ← API REST\n• أنشئ مفتاح API بصلاحيات قراءة/كتابة\n• انسخ Consumer Key و Consumer Secret",
      },
      shopify: {
        title: "كيفية ربط Shopify",
        steps: "1. أدخل نطاق متجرك (مثال: your-store.myshopify.com)\n2. انقر على \"اتصال\"\n3. سيتم توجيهك إلى Shopify\n4. سجل الدخول بحساب المسؤول الخاص بك\n5. انقر على \"تثبيت التطبيق\" للتفويض\n6. جاهز! سيتم توجيهك تلقائياً",
      },
      'whatsapp-business': {
        title: "كيفية الحصول على بيانات اعتماد WhatsApp Business",
        steps: "1. اذهب إلى https://developers.facebook.com/apps/\n2. أنشئ تطبيقاً من نوع \"Business\"\n3. فعل منتج \"WhatsApp\"\n4. قم بإعداد رقم هاتف في \"API Setup\"\n5. انسخ \"Phone Number ID\"\n6. انسخ \"Access Token\" (مؤقت)",
      },
      stripe: {
        title: "كيفية الحصول على مفتاح Stripe الخاص بك",
        steps: "1. اذهب إلى لوحة تحكم Stripe الخاصة بك\n2. اذهب إلى \"المطورين\" ← \"مفاتيح API\"\n3. انسخ \"المفتاح السري\" (sk_live_... أو sk_test_...)\n4. الصقه في الحقل أدناه",
      },
      paypal: {
        title: "كيفية الحصول على بيانات اعتماد PayPal",
        steps: "1. اذهب إلى https://developer.paypal.com/\n2. سجل الدخول بحساب PayPal الخاص بك\n3. اذهب إلى \"My Apps & Credentials\"\n4. أنشئ تطبيق REST API\n5. انسخ \"Client ID\" و \"Secret\"",
      },
      mailchimp: {
        title: "كيفية الحصول على مفتاح API الخاص بـ Mailchimp",
        steps: "1. اذهب إلى حساب Mailchimp الخاص بك\n2. انقر على صورة ملفك الشخصي ← \"الحساب\"\n3. اذهب إلى \"Extras\" ← \"API Keys\"\n4. أنشئ مفتاح API جديد\n5. انسخ المفتاح والبادئة الخاصة بالخادم (مثال: us5)",
      },
      'google-calendar': {
        title: "ربط تقويم جوجل",
        steps: "1. انقر على \"اتصال\"\n2. سيتم توجيهك إلى جوجل\n3. سجل الدخول بحساب جوجل الخاص بك\n4. فوض صلاحيات التقويم\n5. جاهز! سيتم مزامنة أحداثك",
      },
      gmail: {
        title: "ربط Gmail",
        steps: "1. انقر على \"اتصال\"\n2. سيتم توجيهك إلى جوجل\n3. سجل الدخول بحساب جوجل الخاص بك\n4. فوض صلاحيات القراءة/الكتابة\n5. جاهز! سيتم مزامنة رسائل البريد الإلكتروني الخاصة بك",
      },
    },

    helpLinks: {
      shopify: { shopDomain: "كيف أجد النطاق الخاص بي؟" },
      woocommerce: {
        siteUrl: "أين أجد الرابط الخاص بي؟",
        consumerKey: "كيفية إنشاء Consumer Key؟",
        consumerSecret: "كيفية إنشاء Consumer Secret؟",
      },
      'whatsapp-business': {
        phoneNumberId: "كيفية الحصول على Phone Number ID؟",
        accessToken: "كيفية الحصول على Access Token؟",
      },
      stripe: { secretKey: "أين أجد المفتاح السري؟" },
      paypal: {
        clientId: "أين أجد Client ID؟",
        secret: "أين أجد Secret؟",
      },
      mailchimp: {
        apiKey: "كيفية الحصول على مفتاح API؟",
        server: "ما هي بادئة الخادم؟",
      },
      klaviyo: {
        publicKey: "أين أجد المفتاح العام؟",
        privateKey: "أين أجد المفتاح الخاص؟",
      },
      zendesk: {
        subdomain: "ما هو النطاق الفرعي؟",
        email: "أي بريد إلكتروني يجب استخدامه؟",
        apiToken: "كيفية إنشاء رمز API؟",
      },
      livechat: {
        licenseId: "أين أجد License ID؟",
        apiKey: "كيفية الحصول على مفتاح API؟",
      },
      prestashop: {
        url: "أي رابط يجب استخدامه؟",
        apiToken: "كيفية إنشاء رمز API؟",
      },
      cmi: {
        merchantId: "اتصل بـ CMI للحصول على Merchant ID الخاص بك",
        hmacKey: "سوف يزودونك بمفتاح HMAC",
      },
      zapier: { hookUrl: "كيفية إنشاء webhook في Zapier؟" },
    },
    categories: {
      all: "الكل",
      messaging: "المراسلة",
      ecommerce: "التجارة الإلكترونية",
      crm: "إدارة العملاء",
      productivity: "الإنتاجية",
      payment: "المدفوعات",
      other: "أخرى",
    },
  },

  settings: {
    title: "الإعدادات",
    subtitle: "قم بتكوين حسابك وعملك وفواتيرك.",

    tabs: {
      company: "الشركة",
      privacy: "الخصوصية",
      payments: "المدفوعات",
      billing: "الفواتير",
      plan: "الخطة",
      employees: "الموظفون",
      business: "العمل",
    },

    company: {
      sectionTitle: "تفاصيل الشركة",
      panelLanguage: "لغة اللوحة",
      name: "اسم الشركة",
      rc: "السجل التجاري (RC)",
      ice: "التعريف الموحد للمقاولة (ICE)",
      phone: "الهاتف",
      email: "البريد الإلكتروني",
      address: "العنوان",
      website: "الموقع الإلكتروني",
      country: "بلد العمل",
    },

    privacy: {
      usersAccess: "المستخدمون والوصول",
      usersAccessHint: "تحكم في من يمكنه الوصول إلى هذا الحساب.",
      inviteUser: "دعوة مستخدم",
      invitePlaceholder: "email@example.com",
      role: "الدور",
      invite: "دعوة",
      email: "البريد الإلكتروني",
      actions: "إجراءات",
      remove: "إزالة",
      empty: "لا يوجد مستخدمون بعد.",
      security: "الأمان",
      force2fa: "فرض التحقق بخطوتين (2FA)",
      disabled: "معطل",
      requiredAdmins: "مطلوب للمديرين/المالكين",
      requiredAll: "مطلوب للجميع",
      sessionExpiry: "انتهاء الجلسة",
      days7: "7 أيام",
      days30: "30 يوماً",
      days90: "90 يوماً",
      resetPasswords: "إعادة تعيين كلمات المرور",
      sendReset: "إرسال رسائل إعادة التعيين",
      recommended2fa: "موصى به: فرض 2FA للمديرين والمالكين على الأقل.",
      loadingUser: "جاري تحميل المستخدم...",
      cannotIdentifyTenant: "تعذر تحديد الـ tenant",
      changePassword: "تغيير كلمة المرور",
      currentPassword: "كلمة المرور الحالية",
      newPassword: "كلمة المرور الجديدة",
      confirmPassword: "تأكيد كلمة المرور الجديدة",
      allFieldsRequired: "جميع الحقول مطلوبة",
      passwordsDontMatch: "كلمات المرور الجديدة غير متطابقة",
      passwordTooShort: "كلمة المرور يجب أن تكون 6 أحرف على الأقل",
      passwordUpdated: "تم تحديث كلمة المرور بنجاح!",
      noInvitePermission: "ليس لديك صلاحية لدعوة أعضاء جدد.",
      upgradePlan: "قم بترقية خطتك",
    },

    payments: {
      method: "طريقة الدفع",
      openPortal: "فتح البوابة الآمنة",
      desc: "إدارة البطاقة والفواتير في بوابة آمنة (PCI DSS) — مثل Stripe Customer Portal.",
      currentMethod: "الطريقة الحالية",
      holder: "صاحب الحساب",
      loadingTenant: "جاري تحميل معلومات الـ tenant...",
      errorOpeningPortal: "خطأ في فتح البوابة",
      noPortalUrl: "لم يتم استلام رابط البوابة",
      noPaymentMethods: "لا توجد طرق دفع مكونة",
      default: "الافتراضية",
      expires: "تنتهي في",
      manageInStripe: "إدارة في Stripe",
    },

    billing: {
      history: "سجل الفواتير",
      none: "لا توجد فواتير بعد.",
      count: "الفواتير",
    },

    plan: {
      current: "خطتك الحالية",
      plan: "الخطة",
      minutes: "الدقائق المستخدمة (شهرياً)",
      renewal: "التجديد",
      loadingUser: "جاري تحميل المستخدم...",
      noAuthenticatedUser: "لا يوجد مستخدم موثق",
      userHasNoTenant: "المستخدم ليس لديه tenant معين",
      cannotIdentifyTenant: "تعذر تحديد الـ tenant",
      errorCreatingCheckout: "خطأ في إنشاء جلسة الدفع",
      noCheckoutUrl: "لم يتم استلام رابط الدفع",
      errorOpeningPortal: "خطأ في فتح البوابة",
      noPortalUrl: "لم يتم استلام رابط البوابة",
      subscriptionUpdated: "تم تحديث الاشتراك بنجاح!",
      currentPlan: "الحالية",
      manage: "إدارة",
      price: "السعر",
      available: "الخطط المتاحة",
      select: "اختيار",
      noPlan: "ليس لديك أي خطة نشطة.",
    },

    employees: {
      manage: "إدارة الموظفين",
      name: "الاسم",
      position: "المنصب",
      phone: "الهاتف",
      add: "إضافة",
      actions: "إجراءات",
      delete: "حذف",
      empty: "لا يوجد موظفون بعد.",
    },

    business: {
      params: "بارامترات العمل",
      type: "نوع العمل (مفتاح)",
      category: "الفئة / النوع الفرعي (مفتاح)",
      timezone: "التوقيت",
      tables: "عدد الطاولات",
      capacity: "السعة (أشخاص)",
      applyAll: "تطبيق على الكل",
      hours: "المواعيد",
      open: "مفتوح",
      opensAt: "يفتح",
      closesAt: "يغلق",
    },
  },

  dow: {
    mon: "الإثنين",
    tue: "الثلاثاء",
    wed: "الأربعاء",
    thu: "الخميس",
    fri: "الجمعة",
    sat: "السبت",
    sun: "الأحد",
  },

  business: {
    type: {
      restaurant: "مطعم",
      cafe: "مقهى",
      bar: "بار / سهرات",
      hotel: "فندق",
      spa: "سبا",
      clinic: "عيادة",
      salon: "صالون / تجميل",
      gym: "صالة رياضة",
      retail: "تجارة / متجر",
      ecommerce: "تجارة إلكترونية",
      services: "خدمات",
      real_estate: "عقارات",
      other: "آخر",
    },
  },

  ai: {
    title: "مساعد الذكاء الاصطناعي",
    settings: "إعدادات الذكاء الاصطناعي",
    context: "سياق العمل",
    restaurantProfile: "ملف المطعم",
    voiceAssistant: "المساعد الصوتي",
    fileUpload: "تحميل الملفات",
    messages: "المحادثات",
    training: "التدريب",
    suggestions: "اقتراحات",
    generate: "توليد",
    regenerating: "جاري إعادة التوليد...",
    prompt: "الأمر (Prompt)",
    response: "الاستجابة",
    copy: "نسخ",
    copied: "تم النسخ",
    unblockAI: "إلغاء حظر الذكاء الاصطناعي",
    blockAI: "حظر الذكاء الاصطناعي",
    blockedManually: "تم الحظر يدوياً",
  },

  restaurant: {
    editor: "محرر المطعم",
    loading: "جاري تحميل بيانات المطعم...",
    readOnly: "للقراءة فقط",
    lastSaved: "آخر حفظ",
    editMode: "وضع التعديل",
    preview: "معاينة",
    profilePreview: "معاينة الملف الشخصي",
    saveChanges: "حفظ التغييرات",
    notSpecified: "غير محدد",
    cuisineType: "نوع المطبخ",
    checkInPerson: "الاستفسار في الموقع",
    liveRoom: "الغرفة المباشرة",
    soon: "قريباً",
    inRoom: "في الصالة",
    newCustomer: "عميل جديد",
    assignTable: "تعيين طاولة",
    waitlist: "قائمة الانتظار",
    addToWaitlist: "إضافة للانتظار",
    noFreeTables: "لا توجد طاولات شاغرة لـ {{pax}} أشخاص",
    view: "عرض",
    list: "قائمة",
    map: "خريطة",
    swipeHint: "الطاولات · اسحب ← → لتغيير الحالة",
    upcoming: "القادمة",
    noUpcomingBookings: "لا توجد حجوزات قادمة",
    tapToMarkArrival: "اضغط لتسجيل الوصول",
    hotTables: "طاولات ساخنة",
    emptyList: "قائمة فارغة",
    noActivity: "لا يوجد نشاط",
    table: "طاولة",
    general: "عام",
    location: "الموقع",
    schedule: "المواعيد",
    tables: "الطاولات",
    features: "المميزات",
    celebrations: "الاحتفالات",
    menu: "المنيو",
    policies: "السياسات",
    publish: "نشر",
    unpublish: "إلغاء النشر",
    published: "تم النشر",
    draft: "مسودة",
    capacity: "السعة",
    combinable: "قابل للدمج",
    zones: "المناطق",

    status: {
      free: "شاغرة",
      reserved: "محجوزة",
      occupied: "مشغولة",
      cleaning: "تنظيف",
    },

    errors: {
      cannotResolveTenant: "تعذر تحديد الـ tenant الحالي.",
      loginAgain: "سجل دخولك مرة أخرى وحاول مجدداً.",
    },

    generalSection: {
      title: "معلومات عامة",
      name: "اسم المطعم",
      namePlaceholder: "مثال: مطعم الركن",
      phone: "الهاتف",
      phonePlaceholder: "+212 600 000000",
      email: "البريد الإلكتروني",
      emailPlaceholder: "info@restaurant.com",
      founded: "سنة التأسيس",
      foundedPlaceholder: "1998",
      capacity: "السعة",
      capacityPlaceholder: "80",
      description: "الوصف",
      descriptionPlaceholder: "صف المطعم، تاريخه وعرضه...",
      social: "شبكات التواصل الاجتماعي",
      facebookPlaceholder: "facebook.com/...",
      instagramPlaceholder: "@user",
      xPlaceholder: "@user",
      classification: "التصنيف",
      cuisine: "نوع المطبخ",
      dietary: "خيارات غذائية",
      ambience: "الأجواء",
      specialties: "تخصصات الشيف",
      certifications: "الشهادات",
      owner: "المالك / الشيف",
      ownerName: "الاسم",
      ownerNamePlaceholder: "مثال: يونس بناني",
      ownerBio: "السيرة الذاتية",
      ownerBioPlaceholder: "تاريخ الشيف...",
      funFacts: "طرائف وحقائق",
      funFactsPlaceholder: "مثال: الوصفة السرية تعود لأكثر من 50 عاماً في العائلة...",
    },

    certifications: {
      halal: "حلال",
      organic: "عضوي",
      sustainable: "مستدام",
      michelin: "ميشلان",
      glutenFree: "خالٍ من الجلوتين",
      vegan: "نباتي صرف",
      vegetarian: "نباتي",
    },

    schedule: {
      venueHours: "مواعيد العمل",
      copyMonday: "نسخ الإثنين للكل",
      closed: "مغلق",
      morning: "صباحاً / ظهراً",
      evening: "مساءً",
      notApplicable: "لا ينطبق",
      kitchenHours: "مواعيد المطبخ",
      closedKitchen: "مغلق",
      mealServices: "خدمات الطعام",
      breakfast: "فطور",
      brunch: "برنش",
      lunch: "غداء",
      dinner: "عشاء",
      lateNight: "وقت متأخر",
      twoDinnerShifts: "فترتا عشاء",
      firstShift: "الفترة الأولى",
      secondShift: "الفترة الثانية",
      holidays: "العطلات والإغلاقات الخاصة",
      noHolidays: "لا توجد عطلات مكونة",
      holidayReason: "السبب (عيد، رمضان...)",
      seasonalHours: "المواعيد الموسمية",
      summer: "الصيف",
      winter: "الشتاء",
      ramadan: "رمضان",
    },

    features: {
      venueFeatures: "مميزات المكان",
      accessibility: "سهولة الوصول",
      services: "الخدمات",
      paymentMethods: "طرق الدفع",
      soundEnvironment: "البيئة الصوتية",
      hasBackgroundMusic: "توجد موسيقى خلفية",
      mainGenres: "الأنواع الرئيسية",
      volumeLevel: "مستوى الصوت المعتاد",
      liveMusic: "موسيقى حية",
      frequency: "التكرار",
      liveMusicTypes: "أنواع الموسيقى الحية",
      approximateSchedule: "المواعيد التقريبية",
      schedulePlaceholder: "مثال: الجمعة والسبت 20:00-23:00",
      atmosphere: "الأجواء والمناخ",
      roomTemperature: "درجة حرارة الغرفة",
      climateSystem: "نظام المناخ",
      lighting: "أجواء الإضاءة",
      outdoorSeating: "جلسات خارجية",
      heatedTerrace: "تراس مكيف",
      fans: "مراوح",
      entertainment: "الترفيه",
      sustainability: "الاستدامة",
      technology: "التكنولوجيا",

      volumeLevels: {
        quiet: "منخفض / محادثة",
        medium: "متوسط",
        loud: "مرتفع",
      },
      frequencies: {
        daily: "يومياً",
        weekends: "نهاية الأسبوع",
        weekly: "مرة في الأسبوع",
        occasional: "مناسبات خاصة",
      },
      temperature: {
        cold: "بارد (تكييف قوي)",
        comfortable: "مريح (21-23°م)",
        warm: "دافئ (تدفئة)",
        variable: "متغير حسب المنطقة",
      },
      climateSystem: {
        ac: "تكييف هواء",
        heating: "تدفئة",
        both: "كلاهما",
        natural: "تهوية طبيعية فقط",
      },
      lighting: {
        bright: "إضاءة ساطعة",
        ambient: "إضاءة محيطة",
        dim: "إضاءة خافتة / رومانسية",
        adjustable: "قابلة للتعديل حسب المنطقة",
      },
      techItems: {
        qrMenus: "منيو QR",
        ownApp: "تطبيق خاص",
        nfcPayment: "دفع NFC",
        digitalWaitlist: "قائمة انتظار رقمية",
      },
    },

    celebrations: {
      title: "الاحتفالات والمناسبات الخاصة",
      birthdayCake: "كيكة عيد ميلاد",
      price: "السعر",
      numberOfPeople: "عدد الأشخاص",
      specialPackages: "باقات خاصة",
      addPackage: "إضافة باقة",
      noPackages: "لا توجد باقات مكونة",
      packageName: "اسم الباقة",
      packageDescription: "وصف الباقة",
      description: "الوصف",
      options: {
        birthday: "عيد ميلاد",
        anniversary: "ذكرى سنوية",
        engagement: "خطوبة",
        business: "غداء عمل",
        graduation: "تخرج",
        other: "أخرى",
      },
    },

    menu: {
      importWithAI: "استيراد المنيو بالذكاء الاصطناعي",
      importDescription: "استورد قائمتك من PDF، صورة، Word أو Excel. سيقوم الذكاء الاصطناعي باستخراج الفئات والأطباق والأسعار والحساسية تلقائياً.",
      supportedFormats: "الصيغ المدعومة: PDF, JPG, PNG, DOCX, XLSX · الحد الأقصى 10 ميجا",
      processing: "جاري المعالجة...",
      importMenu: "استيراد القائمة",
      ocrHint: "سيكتشف استيراد OCR اللغة تلقائياً وسيقوم الذكاء الاصطناعي بتوحيد الأسماء والأسعار.",
      categories: "الفئات",
      newCategory: "فئة جديدة",
      editCategory: "تعديل الفئة",
      noCategories: "لا توجد فئات. أنشئ واحدة أو استورد قائمتك.",
      categoryNamePlaceholder: "مثال: مقبلات، لحوم، حلويات...",
      categoryDescriptionPlaceholder: "وصف اختياري للفئة",
      categoryUpdated: "تم تحديث الفئة",
      categoryCreated: "تم إنشاء الفئة",
      categoryDeleted: "تم حذف الفئة",
      confirmDeleteCategory: "هل تريد حذف هذه الفئة وجميع أطباقها؟",
      dishes: "الأطباق",
      newDish: "طبق جديد",
      editDish: "تعديل الطبق",
      loadingDishes: "جاري تحميل الأطباق...",
      noDishes: "لا توجد أطباق في هذه الفئة.",
      dishName: "اسم الطبق",
      dishNamePlaceholder: "مثال: سلطة سيزر",
      dishDescriptionPlaceholder: "المكونات الرئيسية، طريقة التحضير...",
      category: "الفئة",
      noCategory: "بدون فئة",
      preparationTime: "وقت التحضير (دقائق)",
      calories: "السعرات الحرارية",
      dietaryOptions: "خيارات غذائية",
      dishUpdated: "تم تحديث الطبق",
      dishCreated: "تم إنشاء الطبق",
      dishDeleted: "تم حذف الطبق",
      confirmDeleteDish: "هل تريد حذف هذا الطبق؟",
      processingError: "خطأ في معالجة الملف",
      importError: "خطأ في الاستيراد",
      menuImported: "تم استيراد المنيو: {{categories}} فئات، {{items}} أطباق",
      unnamed: "بدون اسم",

      dietary: {
        vegetarian: "نباتي",
        vegan: "نباتي صرف",
        glutenFree: "خالٍ من الجلوتين",
        spicy: "حار",
      },

      allergens: {
        title: "الحساسية",
        gluten: "جلوتين",
        crustaceans: "قشريات",
        eggs: "بيوض",
        fish: "سمك",
        peanuts: "فول سوداني",
        soy: "صويا",
        dairy: "ألبان",
        nuts: "مكسرات",
        celery: "كرفس",
        mustard: "خردل",
        sesame: "سمسم",
        sulfites: "كبريتيت",
        lupin: "ترمس",
        mollusks: "رخويات",
      },
    },

    policies: {
      bookingPolicies: "سياسات الحجز",
      cancellationHours: "الإلغاء — ساعات قبل",
      noShowPenalty: "غرامة عدم الحضور (%)",
      deposit: "تأمين (عربون)",
      perPerson: "لكل شخص",
      tableHoldTime: "مدة الاحتفاظ بالطاولة (دقائق)",
      restrictions: "القيود",
      minorsAllowed: "يسمح بالقاصرين",
      minorsAccompanied: "قاصرون برفقة بالغين",
      adultsOnly: "للبالغين فقط (+18)",
      petsAllowed: "يسمح بالحيوانات الأليفة",
      serviceAnimals: "حيوانات الخدمة",
      smokingArea: "منطقة تدخين",
      smokingTerrace: "تراس للمدخنين",
      dressCode: "قواعد اللباس",
      groupsWelcome: "نرحب بالمجموعات",
      dressCodeTitle: "قواعد اللباس",
      dressCodeType: "نوع الزي",
      noDressCode: "لا يوجد زي محدد",
      casual: "كاجوال / غير رسمي",
      smartCasual: "كاجوال أنيق",
      elegante: "أنيق",
      formal: "رسمي (بدلة)",
      traditional: "تقليدي",
      dressCodePlaceholder: "مثال: يطلب زي أنيق، جاكيت للرجال...",
      groupPolicies: "سياسات المجموعات",
      minGroupSize: "أدنى عدد للمجموعة",
      advanceNotice: "المهلة المطلوبة (ساعات)",
      specialGroupPolicy: "سياسة خاصة للمجموعات",
      specialGroupPolicyPlaceholder: "مثال: منيو محدد إلزامي، عربون 30%...",
      children: "الأطفال",
      kidsMenu: "منيو أطفال",
      notAvailable: "غير متاح",
      available: "متاح",
      customizable: "منيو قابل للتخصيص",
      childAgeLimit: "أقصى عمر للطفل (سنوات)",
      highChairs: "كراسي أطفال متاحة",
      changingTable: "طاولة غيار في الحمامات",
      playArea: "منطقة ألعاب",
      pets: "الحيوانات الأليفة",
      petPolicy: "سياسة الحيوانات الأليفة",
      noPets: "لا يسمح بالحيوانات الأليفة",
      serviceAnimalsOnly: "حيوانات الخدمة فقط",
      teraceOnly: "في التراس فقط",
      allAllowed: "مسموح بها في كامل المكان",
      waterBowl: "وعاء ماء متاح",
      treats: "وجبات خفيفة للحيوانات",
      health: "الصحة",
      masksRequired: "الكمامة مطلوبة",
      vaccinationRequired: "التلقيح مطلوب",
      maxCapacity: "السعة القصوى",
      capacityPlaceholder: "مثال: 50",
      inclusivity: "الشمولية",
      lgbtqFriendly: "صديق للجميع",
      accessibleAll: "متاح للجميع",
      diversityStatement: "بيان التنوع",
      diversityPlaceholder: "مثال: نرحب بالجميع بغض النظر عن...",
      legalTerms: "الشروط القانونية",
      privacyPolicy: "سياسة الخصوصية (رابط أو نص)",
      privacyPlaceholder: "https://... أو نص السياسة",
      termsAndConditions: "الشروط والأحكام",
      termsPlaceholder: "شروط وأحكام الحجز...",
      gdprCompliant: "متوافق مع قوانين حماية البيانات (GDPR)",
    },
  },

  automations: {
    title: "الأتمتة",
    subtitle: "اربط الأحداث بإجراءات تلقائية بدون كود.",
    newAutomation: "أتمتة جديدة",
    new: "جديد",
    active: "نشط",
    inactive: "غير نشط",
    test: "اختبار",
    testing: "جاري الاختبار...",
    testSuccess: "تم تنفيذ الاختبار بنجاح ✅",
    testError: "خطأ في الاختبار",
    noAutomations: "لا توجد أتمتة",
    noAutomationsDesc: "أنشئ أول أتمتة لك أو استخدم قالباً للبدء بسرعة.",
    viewTemplates: "عرض القوالب",
    createFromScratch: "إنشاء من الصفر",
    generateWithAI: "توليد بالذكاء الاصطناعي",
    use: "استخدام",
    deleteTitle: "حذف الأتمتة؟",
    deleteConfirm: "لا يمكن التراجع عن هذا الإجراء.",
    when: "عندما",
    before: "قبل",
    delay: "تأخير",
    addStep: "إضافة خطوة",
    selectTrigger: "اختر الحدث الذي يفعل هذه الأتمتة:",
    whenThisHappens: "عندما يحدث هذا...",
    executeTheseActions: "تنفيذ هذه الإجراءات:",
    requiresTimeConfig: "يتطلب إعدادات الوقت",
    willSend: "سيتم الإرسال",
    beforeBooking: "قبل الحجز",
    ofWait: "انتظار",
    automationName: "اسم الأتمتة",
    clickToInsert: "اضغط على متغير لإدراجه:",
    example: "مثال",

    categories: {
      ecommerce: "التجارة الإلكترونية",
      bookings: "الحجوزات",
      messages: "الرسائل",
      advanced: "متقدم",
      control: "التحكم",
    },

    triggers: {
      newOrderWoo: "طلب جديد (WooCommerce)",
      newOrderWooDesc: "يفعل عند استلام طلب جديد في متجرك.",
      orderUpdatedWoo: "تحديث طلب (WooCommerce)",
      orderUpdatedWooDesc: "يفعل عند تغيير حالة طلب موجود.",
      bookingReminder: "تذكير بالحجز",
      bookingReminderDesc: "إرسال إشعار للعميل قبل حجزه. أنت تختار المدة.",
      newBookingConfirmed: "تأكيد حجز جديد",
      newBookingConfirmedDesc: "يفعل عند إنشاء حجز جديد في النظام.",
      newWhatsAppMessage: "رسالة واتساب جديدة",
      newWhatsAppMessageDesc: "يفعل عندما يرسل العميل رسالة عبر واتساب.",
      incomingWebhook: "Webhook وارد",
      incomingWebhookDesc: "يفعل عند استلام طلب HTTP خارجي.",
    },

    variables: {
      orderId: "رقم الطلب",
      orderTotal: "إجمالي الطلب",
      orderStatus: "حالة الطلب",
      newStatus: "الحالة الجديدة",
      customerName: "اسم العميل",
      customerPhone: "هاتف العميل",
      customerEmail: "بريد العميل",
      productNames: "منتجات الطلب",
      phone: "الهاتف",
      bookingDate: "تاريخ الحجز",
      bookingTime: "وقت الحجز",
      time: "الوقت",
      people: "عدد الأشخاص",
      reference: "المرجع",
      messageText: "نص الرسالة",
      webhookData: "بيانات Webhook",
    },

    fields: {
      sendBefore: "الإرسال قبل كم من الوقت",
      timeUnit: "وحدة الوقت",
      templateName: "اسم القالب",
      language: "اللغة",
      jsonBody: "Body JSON (اختياري)",
      wait: "انتظار",
      unit: "الوحدة",
    },

    units: {
      minutesBefore: "دقائق قبل",
      hoursBefore: "ساعات قبل",
      daysBefore: "أيام قبل",
      minutes: "دقائق",
      hours: "ساعات",
      days: "أيام",
      short: {
        minutes: "د",
        hours: "س",
        days: "ي",
      },
    },

    languages: {
      spanish: "الإسبانية",
      french: "الفرنسية",
      english: "الإنجليزية",
      arabic: "العربية",
    },

    actions: {
      sendWhatsApp: "إرسال رسالة واتساب",
      sendWhatsAppDesc: "يرسل رسالة نصية عبر واتساب للعميل.",
      sendTemplate: "إرسال قالب واتساب",
      sendTemplateDesc: "يرسل قالباً رسمياً معتمداً من ميتا.",
      callExternalUrl: "طلب رابط خارجي (URL)",
      callExternalUrlDesc: "يقوم بطلب HTTP POST إلى رابط خارجي.",
      wait: "انتظار لفترة",
      waitDesc: "توقف مؤقت لمدة X دقائق/ساعات/أيام قبل الإجراء التالي",
    },

    placeholders: {
      example2: "مثال: 2",
      example7: "مثال: 7",
      messageExample: "مثال: مرحباً {{customer_name}}! نذكرك بحجزك يوم {{booking_date}} الساعة {{booking_time}} ✅",
    },

    templates: {
      title: "قوالب الأتمتة",
      orderConfirmation: "تأكيد الطلب",
      orderConfirmationDesc: "عند وصول طلب جديد، أرسل تأكيداً تلقائياً عبر واتساب.",
      reminder2h: "تذكير بالحجز قبل ساعتين",
      reminder2hDesc: "ينبه العميل قبل ساعتين من حجزه.",
      reminder1d: "تذكير بالحجز قبل يوم واحد",
      reminder1dDesc: "ينبه العميل في اليوم السابق لحجزه.",
      orderShipped: "شحن الطلب ← تنبيه واتساب",
      orderShippedDesc: "عندما تتغير حالة الطلب إلى \"جاري المعالجة\"، أبلغ العميل.",
      review7d: "طلب تقييم بعد 7 أيام",
      review7dDesc: "اطلب تقييماً بعد أسبوع من الشراء.",
    },

    templateMessages: {
      orderConfirmation: "مرحباً {{customer_name}}! 🎉\n\nلقد استلمنا طلبك رقم {{order_id}}.\n\n🛍️ المنتجات: {{product_names}}\n💰 الإجمالي: {{order_total}}\n\nسنخبرك عندما يكون في الطريق. شكراً لشرائك!",
      reminder2h: "مرحباً {{customer_name}}! 👋\n\nنذكرك بحجزك اليوم الساعة *{{booking_time}}* لـ {{people}} أشخاص.\n\nإذا كنت بحاجة لتغيير أي شيء، رد على هذه الرسالة.\n\nنراك قريباً! 🍽️",
      reminder1d: "مرحباً {{customer_name}}! 😊\n\nنذكرك بأن لديك غداً *{{booking_date}}* حجزاً الساعة *{{booking_time}}* لـ {{people}} أشخاص.\n\nالمرجع: {{reference}}\n\nهل تحتاج إلى إلغاء أو تعديل؟ راسلنا هنا.",
      orderShipped: "مرحباً {{customer_name}}! 📦\n\nطلبك رقم {{order_id}} قيد التحضير.\nستتلقى قريباً مزيداً من المعلومات حول الشحن.",
      review7d: "مرحباً {{customer_name}}! ⭐\n\nنأمل أنك تستمتع بطلبك رقم {{order_id}}.\n\nهل يمكنك ترك تقييم لنا؟ رأيك يهمنا كثيراً. شكراً!",
    },

    errors: {
      selectTrigger: "اختر مشغلاً (Trigger)",
      addAtLeastOneAction: "أضف إجراءً واحداً على الأقل (ليس فقط تأخيراً)",
      configureReminder: "قم بتكوين مهلة التذكير (الكمية والوحدة)",
      saveFailed: "فشل الحفظ",
      unknownError: "خطأ غير معروف",
      saveFirst: "احفظ الأتمتة أولاً",
    },

    aiAssistant: "مساعد الذكاء الاصطناعي",
    aiDescription: "صف الأتمتة التي تريدها بلغة طبيعية",
    aiWhatToAutomate: "ماذا تريد أن تؤتمت؟",
    aiPlaceholder: "مثال: أرسل رسالة واتساب للعميل بعد 7 أيام من طلبه لطلب تقييم...",
    aiEnterHint: "اضغط Enter للتوليد · Shift+Enter لسطر جديد",
    aiExampleRequests: "أمثلة على الطلبات",
    aiGenerating: "جاري التوليد...",
    aiProcessing: "Mistral يعالج طلبك الآن",
    aiGenerated: "تم توليد الأتمتة",
    aiReviewHint: "راجع الرسالة المولدة وقم بتعديلها قبل تفعيل الأتمتة.",
    aiNewRequest: "طلب جديد",
    aiUseThis: "استخدام هذه الأتمتة",
    aiGenerate: "توليد",

    aiSuggestions: {
      confirmation: "إرسال تأكيد واتساب عند وصول طلب جديد",
      reminder2h: "تذكير العميل بالحجز قبل ساعتين",
      review7d: "طلب تقييم بعد 7 أيام من الطلب",
      processing: "تنبيه العميل عندما تتغير حالة طلبه إلى \"جاري المعالجة\"",
      welcome: "رسالة ترحيب عند وصول رسالة واتساب جديدة",
      reminder1d: "تذكير بالحجز في اليوم السابق",
    },

    aiErrors: {
      generationFailed: "فشل توليد الأتمتة",
      connectionError: "خطأ في الاتصال. تأكد من أن السيرفر يعمل.",
    },

    waitDays: "انتظار {{count}} يوم",
    waitHours: "انتظار {{count}} ساعة",
    waitMinutes: "انتظار {{count}} دقيقة",
  },

  freelance: {
    manager: "مدير العمل الحر",
    profile: "ملفي الشخصي",
    availability: "التوفر",
    services: "الخدمات",
    media: "الوسائط",
    schedule: "المواعيد",
    general: "عام",
    physicalCharacteristics: "الصفات الجسدية",
    chat: "دردشة",
    preview: "معاينة",
  },


  products: {
    title: "المنتجات",
    all: "جميع المنتجات",
    active: "نشط",
    inactive: "غير نشط",
    outOfStock: "نفد من المخزن",
    lowStock: "مخزون منخفض",
    categories: "الفئات",
    price: "السعر",
    stock: "المخزون",
    sku: "SKU",
    variants: "المتغيرات",
    attributes: "السمات",
    description: "الوصف",
    images: "الصور",
    addProduct: "إضافة منتج",
    editProduct: "تعديل المنتج",
  },

  billing: {
    title: "الفواتير",
    invoices: "الفواتير",
    paymentMethods: "طرق الدفع",
    subscription: "الاشتراك",
    currentPlan: "الخطة الحالية",
    changePlan: "تغيير الخطة",
    cancelPlan: "إلغاء الخطة",
    billingHistory: "سجل الفواتير",
    downloadInvoice: "تحميل الفاتورة",
    amount: "المبلغ",
    date: "التاريخ",
    status: "الحالة",
    paid: "مدفوعة",
    unpaid: "غير مدفوعة",
    overdue: "متأخرة",
  },

  support: {
    contactSupport: "الاتصال بالدعم",
    submitTicket: "إرسال تذكرة",
    ticketHistory: "سجل التذاكر",
    faq: "الأسئلة الشائعة",
    chat: "دردشة مباشرة",
    email: "بريد الدعم",
    phone: "هاتف الدعم",
    priority: "الأولوية",
    low: "منخفضة",
    medium: "متوسطة",
    high: "عالية",
    urgent: "عاجلة",
    subject: "الموضوع",
    message: "الرسالة",
    attachments: "المرفقات",
    submit: "إرسال",
    submitted: "تم الإرسال",
  },

  notifications: {
    title: "التنبيهات",
    all: "الكل",
    unread: "غير مقروءة",
    markAllRead: "تمييز الكل كمقروء",
    clearAll: "مسح الكل",
    empty: "لا توجد تنبيهات",
    settings: "إعدادات التنبيهات",
    emailNotifications: "تنبيهات البريد الإلكتروني",
    pushNotifications: "تنبيهات الدفع (Push)",
    sound: "الصوت",
    desktop: "سطح المكتب",
    mobile: "الجوال",
  },

  calls: {
    title: "المكالمات",
    calls: "المكالمات",
    searchPlaceholder: "بحث بالمعرف، الرقم أو القصد...",
    reset: "إعادة تعيين",
    intent: "القصد (Intent)",
    table: {
      id: "ID",
      from: "من",
      to: "إلى",
      duration: "المدة",
      toLabel: "إلى",
    },
    intents: {
      booking: "حجز",
      menu: "منيو",
      complaint: "شكوى",
      schedule: "المواعيد",
      location: "الموقع",
      payment: "الدفع",
      menuLetter: "المنيو",
    },
    status: {
      ok: "موافق",
      ongoing: "جارية",
      failed: "فاشلة",
    },
    comingSoon: {
      title: "مكالمات الذكاء الاصطناعي",
      description: "هذا القسم سيكون متاحاً قريباً. ستتمكن من عرض وتصفية وتحليل جميع مكالماتك التي يديرها الذكاء الاصطناعي.",
      badge: "قريباً",
    },
    call: "مكالمة",
    detailSubtitle: "ملخص وتفريغ المكالمة.",
    backToList: "العودة إلى المكالمات",
    participants: "المشاركون",
    audio: "الصوت",
    download: "تحميل",
    noAudio: "لا يوجد صوت متاح لهذه المكالمة.",
    transcript: "تفريغ المكالمة",
    assistant: "المساعد",
    user: "المستخدم",
    metadata: "البيانات الوصفية",
    processedMeta: "المعالجة STT←GPT→TTS: ~620ms",
    audioQuality: "جودة الصوت: 8k μ-law",
    detectedLanguage: "اللغة المكتشفة: ar/fr/es",
  },

  errors: {
    somethingWentWrong: "حدث خطأ ما",
    tryAgain: "حاول مرة أخرى",
    pageNotFound: "الصفحة غير موجودة",
    unauthorized: "غير مصرح به",
    forbidden: "الوصول ممنوع",
    serverError: "خطأ في السيرفر",
    networkError: "خطأ في الشبكة",
    validationError: "خطأ في التحقق",
    required: "هذا الحقل مطلوب",
    invalidEmail: "بريد إلكتروني غير صالح",
    invalidPhone: "رقم هاتف غير صالح",
    minLength: "الحد الأدنى {{min}} أحرف",
    maxLength: "الحد الأقصى {{max}} أحرف",
    passwordMismatch: "كلمات المرور غير متطابقة",
    tenantNotFound: "تعذر تحديد الـ tenant. يرجى التحديث.",
  },
} as const;

export default ar;
